import React from 'react';
import { PopupDialog } from 'swag-client-common/components/info/popup-dialog';
import { Button } from 'swag-client-common/components/ui/button';
import styles from './styles.scss';
const classes = {
  paper: styles.validationConflictPaper
};
export const ItemsValidationConflictPopup = ({
  open,
  onClose,
  title,
  message
}) => {
  return /*#__PURE__*/React.createElement(PopupDialog, {
    dataPopup: "StandaloneItemsValidationConflictPopup",
    showCloseButton: true,
    open: open,
    contentClass: styles.contentClass,
    titleHeader: styles.titleHeader,
    classes: classes,
    onClose: onClose,
    title: renderTitle({
      title
    }),
    content: renderContent({
      message,
      onClose
    })
  });
};
const renderTitle = ({
  title
}) => /*#__PURE__*/React.createElement("div", {
  className: styles.title
}, title);
const renderContent = ({
  message,
  onClose
}) => /*#__PURE__*/React.createElement("div", {
  className: styles.contentWrapper
}, /*#__PURE__*/React.createElement("span", {
  className: styles.contentText
}, message), /*#__PURE__*/React.createElement(Button, {
  type: "primary",
  size: "small",
  onClick: onClose,
  dataButton: "GoBacktoCart",
  className: styles.button
}, "Go Back"));